// OM: Hover open mega menu (Desktop only)
(() => {
  const mq = window.matchMedia('(min-width: 990px)');
  if (!mq.matches) return;

  const detailsList = document.querySelectorAll('details.mega-menu');

  const closeAll = (except) => {
    detailsList.forEach((d) => {
      if (d !== except) d.removeAttribute('open');
    });
  };

  detailsList.forEach((details) => {
    let t;

    details.addEventListener('mouseenter', () => {
      clearTimeout(t);
      closeAll(details);
      details.setAttribute('open', '');
    });

    details.addEventListener('mouseleave', () => {
      clearTimeout(t);
      t = setTimeout(() => details.removeAttribute('open'), 120);
    });

    // 点击 summary 仍然可用（不破坏原逻辑）
    const summary = details.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', () => closeAll(details));
    }
  });

  // 点击页面其他地方关闭
  document.addEventListener('click', (e) => {
    const inside = e.target.closest('details.mega-menu');
    if (!inside) closeAll(null);
  });
})();
